import { THOUSANDS_REG_EXP } from '@/constants/regExp'

export const normalizeMoneyString = (value: string) => {
  if (!value)
    return '0'

  return value
    .replace(/[\u00A0 ]/g, '')
    .replace(',', '.')
    .replace(/[^0-9.]/g, '')
}

export const formatMoney = (value: number | string): string => {
  const stringifiedValue = typeof value === 'number' ? value.toString() : value
  let [integerPart, decimalPart] = stringifiedValue.split(/,|\./)
  integerPart = integerPart.replace(THOUSANDS_REG_EXP, ' ')

  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart
}

export const parseAndClampDiscount = (value?: string | number | null) => {
  const normalized = normalizeMoneyString(value ? value.toString() : '0')
  const parsed = normalized ? Number(normalized) : 0

  if (Number.isNaN(parsed)) {
    return {
      discount: Number.NaN,
      wasClamped: false,
    }
  }

  const clamped = Math.min(100, Math.max(0, parsed))

  return {
    discount: clamped,
    wasClamped: clamped !== parsed,
  }
}

export const calculateFinalPrice = (basePrice: number, discount: number) => {
  if (!basePrice)
    return 0

  return discount ? Math.round((basePrice * (100 - discount)) / 100) : basePrice
}

export const calculateBasePriceFromFinal = (finalPrice: number, discount: number) => {
  if (!finalPrice)
    return 0
  if (discount === 100)
    return finalPrice

  return discount ? (finalPrice * 100) / (100 - discount) : finalPrice
}
